import type { RefObject } from 'react';

/** Scroll target must use `.scroll-margin-header` (or `[id]`) for sticky header offset. */
export function scrollToElement(ref: RefObject<HTMLElement | null>): void {
  ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
